const layers = (state = [], action) => {
  switch (action.type) {
    case 'ADD_LAYER':
      return {
        ...state,
          [action.id]: {
            id: action.id,
            group: action.group,
            exclusive: action.exclusive,
            title: "Test title",
            popup: action.popup,
            visible: true
          },
      }
    case 'REMOVE_LAYER':
      return {
        ...state,
          [action.id]: {
            id: action.id,
            title: "Test title",
            visible: false
          },
      }
    default:
      return state
  }
}

export default layers



// WEBPACK FOOTER //
// ./src/reducers/layers.js